export const CONNECTION_OBJECT_AREA_UNAVAILABLE_MESSAGE =
  'Für die von Ihnen eingegebene Adresse ist die angefragte Sparte nicht verfügbar.';

export function isConnectionObjectAreaAvailabilityValid(
  availableAreas: unknown[] | null | undefined,
  areaAvailable: boolean
): boolean {
  if (!availableAreas?.length) {
    return true;
  }
  return areaAvailable;
}
